import type { WorktreeBaseBranches } from '@buildautomaton/types';
import type { LogFn } from '../log.js';
import { prepareNewIsolatedWorktrees } from './prepare/index.js';
import type { WorktreeLayoutFile } from './worktree-layout-file.js';
import { defaultBranchNameForLayoutKind } from './worktree-layout-kind.js';

export interface PrepareSessionWorktreesResult {
  worktreePaths: string[];
  /** `{worktreesRoot}/{bridgeKey}/{sessionId}` — session root (mirrors bridge repo tree under here). */
  sessionParentPath: string;
}

export async function prepareNewSessionWorktrees(options: {
  worktreesRootPath: string;
  bridgeRoot: string;
  sessionId: string;
  layout: WorktreeLayoutFile;
  log: LogFn;
  /** Optional base branch per repo rel path (from bridge root). */
  worktreeBaseBranches?: WorktreeBaseBranches;
}): Promise<PrepareSessionWorktreesResult | null> {
  const { sessionId, worktreesRootPath, bridgeRoot, layout, log, worktreeBaseBranches } = options;
  const binding = await prepareNewIsolatedWorktrees({
    kind: 'session',
    scopeId: sessionId,
    branch: defaultBranchNameForLayoutKind('session', sessionId),
    worktreesRootPath,
    bridgeRoot,
    layout,
    log,
    ...(worktreeBaseBranches && Object.keys(worktreeBaseBranches).length > 0
      ? { worktreeBaseBranches }
      : {}),
  });
  if (!binding) return null;
  return {
    worktreePaths: binding.repoCheckoutPaths,
    sessionParentPath: binding.parentPath,
  };
}
